import { render, staticRenderFns } from "./IndustryLayout.vue?vue&type=template&id=7f1c4beb&scoped=true"
import script from "./IndustryLayout.vue?vue&type=script&lang=js"
export * from "./IndustryLayout.vue?vue&type=script&lang=js"
import style0 from "./IndustryLayout.vue?vue&type=style&index=0&id=7f1c4beb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1c4beb",
  null
  
)

export default component.exports